module.exports = "pegasus/assets/space.png";